import * as React from "react"

const StopRecordingIcon = (props: any) => (
    <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx={12.5} cy={12} r={12} fill="#CB2F4B" />
        <rect x={7.357} y={6.857} width={10.286} height={10.286} rx={1} fill="#fff" />
    </svg>
)

export default StopRecordingIcon
